import React from 'react';
import { BQLink } from '../../../atoms/bqlink';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import LinkList from '../../../molecules/link-list';
import SocialShare from '../social-share-icon-list';
import { COPYRIGHT_LINKS, EXTERNAL, STRINGS, STORE_LINKS } from '../../../../constants';
import { clickPreferredSourceBadge, downloadAppDl } from '../../../../helpers/datalayer-utils';

import './copyright-section.m.css';

const CopyRightSection = ({ pageType, userData }) => {
  const googleBadge = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'google_badge_content'], {}),
  );
  return (
    <div styleName="copyright">
      <div styleName="social-wrapper">
        <div styleName="social-section">
          <div styleName="social-icons-wrapper">
            <h6 styleName="social-heading">{STRINGS.FOLLOW_US}</h6>
            <div styleName="social-icons">
              <SocialShare sectionName="footer" />
              <div
                styleName="stock-exchange-msg"
                dangerouslySetInnerHTML={{ __html: STRINGS.STOCK_EXCHANGE_MSG }}
              ></div>
            </div>
          </div>
        </div>
        {googleBadge?.lightBadge && (
          <div styleName="app-badge-section">
            <h6 styleName="badge-heading">{STRINGS?.BADGE_TITLE}</h6>
            <div onClick={() => clickPreferredSourceBadge()}>
              <BQLink
                href={googleBadge?.link}
                target={googleBadge?.target || '_self'}
                styleName="link"
              >
                <div styleName="new-badge">NEW</div>
                <img
                  src={googleBadge?.lightBadge}
                  alt="google-badge"
                  loading="lazy"
                  width="179px"
                  height="52px"
                />
              </BQLink>
            </div>
          </div>
        )}

        <div styleName="app-wrapper">
          <div styleName="app-download-scanner" className="desktop-only">
            <img
              src="/icons/app-barcode.png"
              alt="App Download Scanner"
              width="100%"
              height="100%"
            />
          </div>

          <div styleName="stores">
            <h6 styleName="app-heading">{STRINGS.APP_TEXT}</h6>
            <div styleName="store-links">
              {STORE_LINKS.map((store) => (
                <div onClick={() => downloadAppDl(store?.alt, userData, pageType, 'footer')}>
                  <BQLink
                    key={store.href}
                    href={store.href}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    <img src={store.img} alt={store.alt} width="160px" height="52px" />
                  </BQLink>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div styleName="copyright-wrapper">
        <div styleName="copyright-list">
          <LinkList
            links={COPYRIGHT_LINKS}
            gridType="row"
            sectionDivider="dot"
            isCopyright={true}
          />
        </div>
        <div styleName="copyright-text">
          <BQLink
            styleName="link"
            href={EXTERNAL.NDTV_PROFIT}
            target="_blank"
            rel="noopener noreferrer"
          >
            {STRINGS.GET_YEAR} &copy; {STRINGS.NEW_COPYRIGHT_TEXT}
          </BQLink>
        </div>
      </div>
    </div>
  );
};

export default CopyRightSection;
